import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
import type { Bi } from '../../data/sectors';
import { overviewMap as c } from '../../data/platformOverview';
import { FitScale } from '../digital/FitScale';
import { EcosystemMap, MAP_W, MAP_H } from './EcosystemMap';
import { EcosystemMapMobile } from './EcosystemMapMobile';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PlatformOverviewCore() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section id="comment-fonctionne" className="relative overflow-hidden bg-[#FCFCFE] border-t border-[#EEF0F4] px-6 py-20 lg:py-24 scroll-mt-28" aria-labelledby="platform-core-title" data-id="element-5628" data-mp="124av855yoeih">
      <div className="relative max-w-[1240px] mx-auto" data-id="element-5629" data-mp="1bz2uddf6z9fd">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="text-center max-w-[860px] mx-auto" data-id="element-5630" data-mp="2rgv61v44l9je">
          <p className="font-sans text-[12.5px] font-semibold tracking-[0.28em] uppercase text-[#4F46E5]" data-id="element-5631" data-mp="35nqvwgdo4vfp">{pick(c.eyebrow)}</p>
          <h2 id="platform-core-title" className="mt-5 font-serif text-[2rem] sm:text-[2.5rem] lg:text-[2.8rem] leading-[1.06] tracking-tight" data-id="element-5632" data-mp="39p424rkob0n5">
            {c.headline.map(l => <span key={l.text.fr} className={`block ${l.accent ? 'text-[#4F46E5]' : 'text-[#121A3A]'}`} data-id="element-5633" data-mp="2hyg3pnadw9d6">{pick(l.text)}</span>)}
          </h2>
          <p className="mt-6 max-w-[700px] mx-auto font-sans text-[15.5px] md:text-[16px] text-[#4A5268] leading-relaxed" data-id="element-5634" data-mp="2m01b4t45fvfz">{pick(c.body)}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="mt-14 lg:mt-16" role="img" aria-label={lang === 'FR' ? 'Plusieurs points d’entrée convergent vers BCITI | ATNA, le système nerveux numérique. Elle est reliée aux services BCITI | ATNA, à votre écosystème existant et à votre organisation.' : 'Many entry points converge on BCITI | ATNA, the digital nervous system, connected to BCITI | ATNA services, your existing ecosystem and your organization.'} data-id="element-5635" data-mp="2vpuljqsk24in">
          <div className="hidden md:block" data-id="element-5636" data-mp="2nkjunpmumx39">
            <FitScale width={MAP_W} height={MAP_H} data-id="element-5637" data-mp="2nnfqn8f4zbp2">
              <EcosystemMap data-id="element-5638" data-mp="2in0gsqu2cmbu" />
            </FitScale>
          </div>
          <div className="md:hidden" data-id="element-5639" data-mp="2wm04nw9r4x6y">
            <EcosystemMapMobile data-id="element-5640" data-mp="2wn2r9s01kdh2" />
          </div>
        </motion.div>
      </div>
    </section>;
}